import { createTheme, Theme as MuiTheme } from '@mui/material/styles';
import { SERVICE_COLOR, SERVICE_DARK, SERVICE_LIGHT } from './styleConstants';

// 参考：https://emotion.sh/docs/typescript
declare module '@emotion/react' {
  interface Theme extends MuiTheme {}
}

const theme: MuiTheme = createTheme({
  palette: {
    primary: {
      light: SERVICE_LIGHT,
      main: SERVICE_COLOR,
      dark: SERVICE_DARK,
      contrastText: '#fff',
    },
  },
  spacing: 4,
});

export default theme;
